import { FormGroup, FormParagraph } from '@ksyos/design-system';
import { isNull } from 'lodash';
import type { EmploymentGetOneApiResult } from '@common/interfaces/api/employmentsApi';
import { getDisplayName } from '@common/utils/getDisplayName';
import { getSelectedLanguage } from '@frontend/translate';

interface EmploymentEndedByProps {
    endedByPractitioner: EmploymentGetOneApiResult['endedByPractitioner'];
    isEndedByOrganization: EmploymentGetOneApiResult['isEndedByOrganization'];
}

export function EmploymentEndedBy(props: Readonly<EmploymentEndedByProps>) {
    const translate = getSelectedLanguage();

    return (
        <FormGroup label={translate.common.endedBy}>
            <FormParagraph>{getValue(props)}</FormParagraph>
        </FormGroup>
    );

    function getValue({ endedByPractitioner, isEndedByOrganization }: EmploymentEndedByProps) {
        const hasNoEndedByPractitioner = Object.values(endedByPractitioner).every(isNull);
        const practitionerDisplayName = getDisplayName(endedByPractitioner, false, 'nameGivenNameFamily');

        switch (`${isEndedByOrganization} && ${hasNoEndedByPractitioner}`) {
            case 'true && true':
                return translate.accountDeactivation.employeeFromOrganization;
            case 'true && false':
                return practitionerDisplayName;
            case 'false && true':
                return 'Ksyos';
            case 'false && false':
                return `${practitionerDisplayName} (Ksyos)`;
            default:
                return translate.common.unknown;
        }
    }
}
